(() => {
  const ROOT = '[data-main-brands]';
  const SWIPER_SEL = '[data-embe-brands-featured-swiper]';

  function toFeature(node) {
    return {
      title: node.dataset.title || '',
      text: node.dataset.text || '',
      url: node.dataset.url || '',
      image: node.dataset.image || '',
      imageAlt: node.dataset.imageAlt || ''
    };
  }

  function randomIndex(length, excludeIndex) {
    if (length <= 1) return 0;
    let next = Math.floor(Math.random() * length);
    while (next === excludeIndex) {
      next = Math.floor(Math.random() * length);
    }
    return next;
  }

  function updateCard(card, feature) {
    const titleEl = card.querySelector('[data-brand-feature-title]');
    const textEl = card.querySelector('[data-brand-feature-text]');
    const imageEl = card.querySelector('[data-brand-feature-image]');
    const linkEl = card.querySelector('[data-brand-feature-link]');

    if (!titleEl || !textEl || !imageEl || !linkEl) return;

    titleEl.textContent = feature.title;
    textEl.textContent = feature.text;

    if (feature.url) {
      linkEl.href = feature.url;
      linkEl.setAttribute('aria-label', feature.title || 'Featured brand');
    } else {
      linkEl.removeAttribute('href');
    }

    if (feature.image) {
      imageEl.src = feature.image;
      imageEl.alt = feature.imageAlt || feature.title || '';
      imageEl.style.display = 'block';
      linkEl.style.display = 'block';
    } else {
      imageEl.removeAttribute('src');
      imageEl.alt = '';
      imageEl.style.display = 'none';
      linkEl.style.display = 'none';
    }
  }

  function scrollAlphabetToActiveLink(scroller, activeLink) {
    if (!scroller || !activeLink) return;

    const item = activeLink.closest('.main-brands__alphabet-item');
    if (!item) return;

    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    if (maxScroll <= 0) return;

    const itemStart = item.offsetLeft;
    const itemEnd = itemStart + item.offsetWidth;
    const viewStart = scroller.scrollLeft;
    const viewEnd = viewStart + scroller.clientWidth;
    const inset = 12;

    if (itemStart >= viewStart + inset && itemEnd <= viewEnd - inset) return;

    const target = itemStart - (scroller.clientWidth - item.offsetWidth) / 2;
    const left = Math.max(0, Math.min(maxScroll, target));
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    scroller.scrollTo({ left, behavior });
  }

  function initAlphabetNav(section) {
    if (section._embeBrandsAlphabetNav) return;

    const letters = Array.from(section.querySelectorAll('.main-brands__letter[id]'));
    const links = Array.from(section.querySelectorAll('.main-brands__alphabet-link[href^="#"]'));
    const alphabetScroller = section.querySelector('.main-brands__alphabet');
    if (!letters.length || !links.length) return;

    section._embeBrandsAlphabetNav = true;

    const linkById = new Map();
    links.forEach(function (a) {
      const href = a.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        linkById.set(href.slice(1), a);
      }
    });

    function focusLineY() {
      const wrap = section.querySelector('.main-brands__alphabet-wrap');
      if (!wrap) return 120;
      return wrap.getBoundingClientRect().bottom + 6;
    }

    function updateAlphabetActive() {
      const line = focusLineY();
      let activeIdx = -1;
      for (let i = 0; i < letters.length; i += 1) {
        if (letters[i].getBoundingClientRect().top <= line) {
          activeIdx = i;
        }
      }

      let activeId = '';
      if (activeIdx >= 0) {
        activeId = letters[activeIdx].id;
      } else if (letters[0]) {
        activeId = letters[0].id;
      }

      links.forEach(function (a) {
        a.classList.remove('is-active');
        a.removeAttribute('aria-current');
      });

      const activeLink = activeId ? linkById.get(activeId) : null;
      if (activeLink) {
        activeLink.classList.add('is-active');
        activeLink.setAttribute('aria-current', 'true');
        if (alphabetScroller) {
          scrollAlphabetToActiveLink(alphabetScroller, activeLink);
        }
      }
    }

    let ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateAlphabetActive();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    updateAlphabetActive();

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        const targetId = link.getAttribute('href');
        if (!targetId || targetId.length < 2) return;

        const target = document.querySelector(targetId);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        if (window.history && typeof window.history.replaceState === 'function') {
          window.history.replaceState({}, '', targetId);
        }

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            updateAlphabetActive();
            const active = section.querySelector('.main-brands__alphabet-link.is-active');
            if (active && alphabetScroller) {
              scrollAlphabetToActiveLink(alphabetScroller, active);
            }
          });
        });
      });
    });
  }

  function initStickyAlphabet(section) {
    const card = section.querySelector('[data-brand-feature-card]');
    if (!card) return;

    // const stickyEl = section.querySelector('.main-brands__alphabet-wrap');

    // if (stickyEl) {
    //   const stickyTop =
    //     parseFloat(getComputedStyle(section).getPropertyValue('--brands-alpha-sticky-top')) || 0;

    //   const updateStickyState = () => {
    //     const rect = stickyEl.getBoundingClientRect();
    //     stickyEl.classList.toggle('is-stuck', rect.top <= stickyTop);
    //   };

    //   updateStickyState();

    //   window.addEventListener(
    //     'scroll',
    //     () => {
    //       window.requestAnimationFrame(updateStickyState);
    //     },
    //     { passive: true }
    //   );

    //   window.addEventListener('resize', updateStickyState);
    // }

    const items = Array.from(section.querySelectorAll('.js-brand-feature-data')).map(toFeature);
    if (!items.length) {
      card.setAttribute('hidden', 'hidden');
      return;
    }

    card.removeAttribute('hidden');
    let currentIndex = randomIndex(items.length, -1);
    updateCard(card, items[currentIndex]);

    const threshold = Math.max(80, parseInt(section.dataset.scrollThreshold || '180', 10));
    let lastY = window.scrollY;
    let accumulator = 0;
    let ticking = false;

    function handleScroll() {
      const currentY = window.scrollY;
      accumulator += Math.abs(currentY - lastY);
      lastY = currentY;

      if (accumulator < threshold) return;
      accumulator = 0;

      const nextIndex = randomIndex(items.length, currentIndex);
      currentIndex = nextIndex;
      updateCard(card, items[currentIndex]);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          handleScroll();
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  function initFeaturedSwiper(section) {
    const el = section.querySelector(SWIPER_SEL);
    if (!el || el._embeBrandsFeaturedSwiper) return;

    const run = () => {
      if (!window.Swiper) return false;
      if (el._embeBrandsFeaturedSwiper) return true;

      const slides = el.querySelectorAll('.swiper-slide');
      if (!slides.length) return true;

      const prev = el.querySelector('.swiper-button-prev');
      const next = el.querySelector('.swiper-button-next');
      const pagination = el.querySelector('.swiper-pagination');

      const opts = {
        slidesPerView: 1.5,
        spaceBetween: 8,
        speed: 500,
        roundLengths: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          640: { slidesPerView: 3, spaceBetween: 10 },
          990: { slidesPerView: 4 },
          1300: { slidesPerView: 5 },
          1600: { slidesPerView: 6 }
        }
      };

      if (prev && next) opts.navigation = { prevEl: prev, nextEl: next };
      if (pagination) opts.pagination = { el: pagination, clickable: true };

      try {
        el._embeBrandsFeaturedSwiper = new window.Swiper(el, opts);
      } catch (_) {
        return false;
      }

      return true;
    };

    if (run()) return;

    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (run()) {
        clearInterval(timer);
        return;
      }
      if (tries >= 40) clearInterval(timer);
    }, 100);
  }

  function initSection(section) {
    initAlphabetNav(section);
    initStickyAlphabet(section);
    initFeaturedSwiper(section);
  }

  function boot(root = document) {
    const roots = root.matches?.(ROOT) ? [root] : Array.from(root.querySelectorAll?.(ROOT) || []);
    roots.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
